module.exports = __webpack_public_path__ + "static/media/Mask58.702ca34d.svg";